<template>
     <layout class="mc" type='L_R' style="width:90%;margin:auto;">
     <layout type="T_B">
         <layout type='L_R' flex='1'>
             <layout type='T_B'>
                    <div flex='1.5'>
                        <cell flex='1' type="bottom">
                            <div class="tt1">订单</div>           
                        </cell>
                    </div>
                    <div flex='1' >
                        <cell flex='1' type="top">
                            <div class="tt2">{{data.styleNum||0}}<span style="font-size:12px;">款</span></div>       
                        </cell>            
                    </div>
                    <div flex='1.5'>
                        <cell flex='1' type="top">
                            <div class="tt3">{{data.orderNum||0}}件</div>       
                        </cell>  
                    </div>            
            </layout>
            <layout type='T_B'>
                <div flex='1.5'>
                    <cell flex='1' type="bottom">
                        <div class="tt1">入库</div>           
                    </cell>
                </div>
                <div flex='1' >
                    <cell flex='1' type="top">
                        <div class="tt2">{{data.comeStyleNum||0}}<span style="font-size:12px;">款</span></div>       
                    </cell>            
                </div>
                <div flex='1.5'>
                    <cell flex='1' type="top">
                        <div class="tt3">{{data.comeNum||0}}件</div>       
                    </cell>  
                </div>                
            </layout>
            <layout type='T_B'>
                    <div flex='1.5'>
                        <cell flex='1' type="bottom">
                            <div class="tt1">在产</div>           
                        </cell>
                    </div>
                    <div flex='1' >
                        <cell flex='1' type="top">
                            <div class="tt2">{{data.inProductionStyleNum||0}}<span style="font-size:12px;">款</span></div>       
                        </cell>            
                    </div>
                    <div flex='1.5'>
                        <cell flex='1' type="top">
                            <div class="tt3">{{data.inProductionNum||0}}件</div>       
                        </cell>  
                    </div>
                   
            </layout>
         </layout>
         <layout type="L_R" flex='1.5'>
            <layout type="T_B">
                <div flex='2'>
                    <perant :num="data.onTimeRate||0" :colors="['#377dff','#16ceb9']"/>
                    
                </div>
                <div flex='1'>
                    <cell flex='1' type="top">
                        <div class="tt4">款准交率</div>       
                    </cell>  
                </div>
               
            </layout>
            <layout type="T_B">
                 <div flex='2'>
                        <perant :num="data.errorRate||0" :colors="['#6648ff','#f7517f']"/>                     
                    </div>
                    <div flex='1'>
                        <cell flex='1' type="top">
                            <div class="tt4">款异常率</div>       
                        </cell>  
                    </div>
            </layout>
         </layout>
     </layout>
      
     </layout>
</template>
<script>
import layout from "@/components/cuscom/layout.vue"
import cell from "@/components/cuscom/cell.vue"
import {perant} from "../report/index"

export default {
    components:{
        layout,
        cell,
        perant    
    },
    props:{
        data:{
            type:Object,
            default:()=>{}
        }
    },
    mounted(){
    
    }
}
</script>
<style lang="scss" scoped>


.mc{
   
     color:#c0c8ff;
    .tt1{
        font-size: 14px;
    }
     .tt2{
         font-size: 32px;
          color:#fff;
    }
     .tt3{
         font-size: 24px;
    }
    .tt4{
        font-size: 14px;
    }
}
</style>